import { APIModel } from './api-model.model'

export class APIProvider extends APIModel {
    providerId: number;
    carrierId: number;
    providerName: string;
    providerNotificationEndpoint: string;
    providerEnabled: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        providerId: number;
        carrierId: number;
        providerName: string;
        providerNotificationEndpoint: string;
        providerEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.providerId = params.providerId
        this.carrierId = params.carrierId
        this.providerName = params.providerName
        this.providerNotificationEndpoint = params.providerNotificationEndpoint
        this.providerEnabled = params.providerEnabled ? 1 : 0
    }
}
